/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedBBDocCreateRequest } from '../types/PatchedBBDocCreate';
import type { BBDocCreateResponse } from '../types/BBDocCreate';

export type BbDocsAcceptPartialUpdateRequest = PatchedBBDocCreateRequest;
export type BbDocsAcceptPartialUpdateResponse = BBDocCreateResponse;

export type BbDocsAcceptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/bb_docs/{id}/accept/
 *
 * ```yaml
 * operationId: bb_docs_accept_partial_update
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocCreate'
 *     description: ''
 * ```
 */
export const bbDocsAcceptPartialUpdateOperation = ({
  id,
  ...rest
}: BbDocsAcceptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/bb_docs/${id}/accept/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/bb_docs/{id}/accept/' };
  };

/**
 * PATCH /dmx-server/bb_docs/{id}/accept/
 *
 * ```yaml
 * operationId: bb_docs_accept_partial_update
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocCreate'
 *     description: ''
 * ```
 */
export const bbDocsAcceptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BbDocsAcceptPartialUpdateQuery;
  request: PatchedBBDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<BBDocCreateResponse>> => {
  const operation = bbDocsAcceptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
